// extracted by mini-css-extract-plugin
module.exports = {"textRendering":"UserContent_textRendering__To4py","ui800TextColor":"UserContent_ui800TextColor__FflHt","maxTruncate":"UserContent_maxTruncate__8f7_X"};